import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { modalContentInfoActions as ModalContentInfoActions } from '../../../modals/ModalManageContentInfo';
import AddConfigContentPanel from './AddConfigContentPanel';
import TablePanelView from '../common/TablePanelView';
import { LOGIN_SET_CONFIG, REFRESH_SELECTED_CONFIG_FILE } from '../../../../constants/ActionTypes';
import { checkPermissions } from '../../../../../lib/utils';
import { ConfigurationService, saveTemplateToFrontman } from '../../../../services/ConfigurationService';
import { SAVE_LEVEL } from '../../../../constants/Level';
import { ACCESS_POINTS_GROUP } from '../../../../constants/AccessPoints';
import EditConfig from '../editConfig';
import { isEmpty } from 'lodash';

class ManageConfiguration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            code: '',
            comments: '',
            selectedTheme: '',
            selectedConfig: '',
            isValidationShown: false
        };
        this.copyConfig = this.copyConfig.bind(this);
        this.showValidation = this.showValidation.bind(this);
    }

    componentDidMount() {
        if (!isEmpty(this.props.configList)) {
            this.setSelected(this.props.configList[0].ContentCode);
        }
    }

    setName(input) {
        this.setState({ name: input });
    }

    setCode(input) {
        this.setState({ code: input });
    }

    setComments(input) {
        this.setState({ comments: input });
    }

    setSelected(input) {
        this.setState({ selectedConfig: input });
    }

    clearComments() {
        this.setState({ comments: '', name: '', isValidationShown: false });
    }

    clearCode() {
        this.setState({ code: '' });
    }

    copyConfig(source) {
        const { code } = this.state;
        if (this.state.name && this.state.code) {
            let detailPromise =
                source.level === SAVE_LEVEL.SYSTEM
                    ? ConfigurationService.systemdefault()
                    : ConfigurationService.get(
                          this.props.chain.Id,
                          this.props.selectedHotel.id,
                          source.ContentCode,
                          source.level
                      ).then(response => response.data.BEDesignerResult.Value.Data);
            detailPromise.then(config => {
                const combinedObj = {
                    Data: config,
                    MetaData: {
                        Comment: this.state.comments,
                        Name: this.state.name
                    }
                };
                ConfigurationService.new(
                    this.props.chain.Id,
                    this.props.selectedHotel.id,
                    this.state.code,
                    combinedObj,
                    this.props.level
                ).then(response => {
                    saveTemplateToFrontman({
                        code,
                        chainId: this.props.chain.Id,
                        hotelId: this.props.selectedHotel.id,
                        saveLevel: this.props.level,
                        name: get(combinedObj, 'MetaData.Name')
                    });
                    ConfigurationService.reload(this.props.chain.Id, this.props.selectedHotel.id, this.props.level);
                });
                this.clearComments();
                this.clearCode();
                this.setState({ name: '' });
            });
        }
    }

    showValidation() {
        this.setState({ isValidationShown: true });
    }

    render() {
        const configList = this.props.configList ? this.props.configList : [];
        let configOptions = [];
        configList.length > 0
            ? configList.map(elem => {
                  configOptions.push({
                      key: elem.ContentCode,
                      label: elem.ContentCode
                  });
              })
            : (configOptions = this.props.themelevel.availableThemes);
        const defaultContentConfigCode = this.props.defaultContentConfig ? this.props.defaultContentConfig : false;

        if (/edit-configuration$/.test(this.props.location.pathname)) {
            return <EditConfig currentConfig={this.props.currentConfig} configCode={this.props.configCode} />;
        }

        return (
            <main className="spark-main ManageConfiguration">
                <div className="col-xs-12">
                    {(this.props.permissionSettings.view ||
                        this.props.permissionSettings.edit ||
                        this.props.permissionTrackingHooks.view ||
                        this.props.permissionTrackingHooks.edit) && (
                        <TablePanelView
                            id="themes-panel"
                            
                            clearComments={this.clearComments.bind(this)}
                            clearCode={this.clearCode.bind(this)}
                            defaultContent={defaultContentConfigCode}
                            chain={this.props.chain.Id}
                            hostedContent={configList}
                            hotel={this.props.selectedHotel.id}
                            setData={this.props.setConfig}
                            onBeforeUpload={this.props.onBeforeUpload}
                            contenttype={ACCESS_POINTS_GROUP.CONFIGURATION}
                            inContextContent={configList}
                            itemName="Configuration"
                            uploadUrl="manage-configuration/edit-configuration"
                            onSubmit={this.copyConfig}
                            showValidation={this.showValidation}
                            headline="Configuration (settings)"
                            buttonComment="Add a new Configuration"
                            code={this.state.code}
                            name={this.state.name}
                            onShowInfo={this.props.showModalInfo}
                        >
                            <AddConfigContentPanel
                                selected={this.props.themelevel.selected}
                                population={this.props.themelevel.population}
                                hotels={this.props.themelevel.hotels}
                                availableThemes={configOptions}
                                onDispatch={this.props.onThemeDispatch}
                                setName={this.setName.bind(this)}
                                setCode={this.setCode.bind(this)}
                                setComments={this.setComments.bind(this)}
                                setSelected={this.setSelected.bind(this)}
                                comments={this.state.comments}
                                name={this.state.name}
                                code={this.state.code}
                                isValidationShown={this.state.isValidationShown}
                            />
                        </TablePanelView>
                    )}
                    <hr />
                </div>
            </main>
        );
    }
}

ManageConfiguration.propTypes = {
    children: PropTypes.element,
    onThemeDispatch: PropTypes.func,
    onConfigDispatch: PropTypes.func
};

const mapStateToProps = state => {
    return {
        chainid: state.app.selected.chain.Id,
        ...state.app.data.manage.manage,
        ...state.manage,
        ...state.app.selected,
        configCode: state.app.data.configuration.configuration.configCode,
        currentConfig: state.app.data.configuration.configuration.currentConfig,
        permissionSettings: checkPermissions(state, ACCESS_POINTS_GROUP.CONFIGURATION),
        permissionTrackingHooks: checkPermissions(state, ACCESS_POINTS_GROUP.TRACKING_HOOKS)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        showModalInfo: contentData => {
            dispatch(ModalContentInfoActions.show(contentData));
        },
        setConfig: (config, code) => {
            dispatch({ type: REFRESH_SELECTED_CONFIG_FILE });
            dispatch({ type: LOGIN_SET_CONFIG, config, code });
        },
        onBeforeUpload: () => {
            dispatch({ type: REFRESH_SELECTED_CONFIG_FILE });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageConfiguration);



// WEBPACK FOOTER //
// ./src/components/pages/manage/manageConfiguration/index.js